import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const GRAVEL = "#a89f90";
const GRAVEL_DARK = "#998f7f";
const GRAVEL_LIGHT = "#b5ac9d";
const SOIL = "#6b4a2a";

export const gravelPath = defineModel({
  id: "gravel-path",
  batchId: "modern",
  name: "Gravel path",
  tags: ["modern", "outdoor", "ground", "garden", "path", "gravel"],
  summary: "A gravel path tile with soil edging along both sides.",
  description:
    "A one-tile gravel path of the Modern Living kit: a 1x1 m gravel slab " +
    "(0.06 m thick) with flush lighter/darker specks and thin soil edging " +
    "strips on both X edges. The path runs along Z; tiles seamlessly with " +
    "every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: GRAVEL, position: [0, 0.03, 0] },
      // Soil edging strips on both X edges, full tile length along Z.
      {
        geometry: new THREE.BoxGeometry(0.07, 0.012, 1.0),
        color: SOIL,
        position: [-0.465, 0.06, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.07, 0.012, 1.0),
        color: SOIL,
        position: [0.465, 0.06, 0],
      },
      // Flush speck strips in slightly darker and lighter gravel tones.
      {
        geometry: new THREE.BoxGeometry(0.16, 0.012, 0.1),
        color: GRAVEL_DARK,
        position: [-0.14, 0.06, -0.28],
      },
      {
        geometry: new THREE.BoxGeometry(0.14, 0.012, 0.09),
        color: GRAVEL_LIGHT,
        position: [0.16, 0.06, -0.02],
      },
      {
        geometry: new THREE.BoxGeometry(0.15, 0.012, 0.1),
        color: GRAVEL_DARK,
        position: [-0.08, 0.06, 0.3],
      },
      {
        geometry: new THREE.BoxGeometry(0.12, 0.012, 0.08),
        color: GRAVEL_LIGHT,
        position: [0.12, 0.06, 0.34],
      },
    ];
  },
  animations: [],
});
